import api from '@/api/api'
import store from '@/store/store'
import { resolve, reject } from 'core-js/fn/promise'
const comFun = {
    /*首页 方法*/
    geCarouselFigures(){ // 轮播图
        return new Promise((resolve, reject) => {
            api.get('/api/home/GetWebCarouselFigures',null, Response => {
                resolve(Response.result)
            },error=>{
                reject(error)
            })
        })
    },
    geCourses(){ //课程
        return new Promise((resolve, reject) => {
            api.get('/api/home/GetCourses?type=6&count=8&isbase64=false',null, Response => {
                resolve(Response.result)
            },error=>{
                reject(error)
            })
        })
    },
    geRecommendClass(){ //班级
        return new Promise((resolve, reject) => {
            api.get('/api/home/GetRecommendClass?isbase64=false',null, Response => {
                resolve(Response.result)
            },error=>{
                reject(error)
            })
        })
    },
    geRecommendLives(){ //直播
        return new Promise((resolve, reject) => {
            api.get('/api/home/GetRecommendLives?isbase64=false',null, Response => {
                resolve(Response.result)
            },error=>{
                reject(error)
            })
        })
    },

    /*直播 方法*/
    getLiveList:function(postdata) {
        //postdata.SkipCount = postdata.PageIndex*postdata.MaxResultCount
        if(!postdata.stopajax){
          return new Promise((resolve, reject) => {
            api.get('/api/LiveBroadcast/GetWebLives',{
                page:postdata.PageIndex,
                pageSize:postdata.MaxResultCount,
                isEnd:postdata.IsEnd
            }, Response => {
              resolve(Response)
            },error=>{
              reject(error)
            })
          })
        } 
    },
    playback(item){
        var _user = store.state.userInfo;
        if (_user == null) {
            //MainMenu.login();
            store.dispatch('setShowLogin', true) // 显示登录框
            return false;
        }
        var postdata = {
            Title: item.title,
            Start:item.startDate,
            End: item.endDate,
            room_id: item.room_id,
            Type: 2
        }
        if (_user.id == item.teacherId) {  // 讲师身份
            this.getPlayback(postdata)
        } else {
            api.get('/api/LiveBroadcast/GetLiveUserRole?isBase64=false&id=' + item.id,null, Response => {
                if (Response.result.role!="") {
                    this.getPlayback(postdata)
                } else {
                    var msg = {
                      type:'error',
                      text:'您没有权限观看'
                    }
                     store.dispatch('setMsg', msg)
                }
            },error=>{
              //reject(error)
              console.log(error)
            })
        }
    },
    getPlayback (postdata){
        api.get('/api/LiveBroadcast/GetLiveBackUrl?roomid='+postdata.room_id ,null, data => {
            if (data!="") {
             window.open(data.result, "_blank");
            } else {
              //abp.notify.error('未录制回放', '提示');
               var msg = {
                    type:'error',
                    text:'未录制回放'
                    }
               store.dispatch('setMsg', msg)
            }
        },error=>{
              //reject(error)
              console.log(error)
        })
    },
    start(item){
        var _user = store.state.userInfo;
        if (_user == null) {
            //MainMenu.login();
            store.dispatch('setShowLogin', true) // 显示登录框
            return false;
        }
        if (_user.id == item.teacherId) {  // 讲师身份
            this.getUrl(item.room_id, item.teacherId, 1, 0)
        } else {
            api.get('/api/LiveBroadcast/GetLiveUserRole?isBase64=false&id=' + item.id,null, data => {
              //this.getUrl(item.room_id, item.teacherId, 0, 1)
                if (data.result.role=="student") {
                    this.getUrl(item.room_id, item.teacherId, 0, 1)
                } else {
                    // abp.notify.error('您没有权限观看', '提示');
                    var msg = {
                      type:'error',
                      text:'您没有权限观看'
                    }
                     store.dispatch('setMsg', msg)
                }
            },error=>{
              //reject(error)
              console.log(error)
            })
           
        }
    },
     getUrl (roomid, userid, role, isclient) {
           api.get('/api/LiveBroadcast/GetEnterRoomUrl?roomid=' + roomid +  '&user_role=' + role,null, data => {
               if (!isclient) {
                    // debugger
                    this.getHref(data.result.clientUrl)
                } else {
                    window.open(data.result.webUrl, "_blank");
                }
            },error=>{
              //reject(error)
              console.log(error)
            })
    },
     getHref (url) {
        var isFirefox = navigator.userAgent.indexOf('Firefox') > -1  // 是否是火狐  ，火狐内核Gecko
        var isWebKit = navigator.userAgent.indexOf('WebKit') > -1  // 是否是WebKit 内核
        var isChrome = navigator.userAgent.indexOf('Chrome') > -1  // 是否是谷歌
        var isTrident = navigator.userAgent.indexOf('Trident') > -1  // 是否是IE内核
        var isIeL = !!window.ActiveXObject || "ActiveXObject" in window
        if (isFirefox || isWebKit || isChrome || isTrident || isIeL) {
            // IE和火狐用window.open打开
            // 调起客户端 5秒之后自动关闭调起窗口
            var client = window.open(url);
            setTimeout(function () {
                if (client) {
                    client.close(); //关闭新打开的浏览器窗口，避免留下一个空白窗口
                }
            }, 5000);
        } else {
            //其它浏览器使用模拟<a>标签`click`事件的形式调起
            var a = document.createElement("a");
            a.setAttribute("href", url);
            document.body.appendChild(a);
            a.click();
        }
        setTimeout(function () {
            // 5秒之后不管有没有调起都弹窗提示下载客户端
            // dialog.open();
           
        }, 5000);
    },

    /*课程中心*/
    getAllcourse(postdata){
        return new Promise((resolve, reject) => {
            api.post('/api/services/app/trainCourseExpend/GetCourseList',postdata, Response => {
              resolve(Response.result)
            },error=>{
              reject(error)
            })
         })  
    },
    getCourseLabels(){
        return new Promise((resolve, reject) => {
            api.get('/api/CourseLabel/GetCourseLabels?isBase64=false',null, Response => {
              resolve(Response.result)
            },error=>{
              reject(error)
            })
         })  
    } ,

    /* 班级中心 */
    getCateGoriesList(){
        return new Promise((resolve, reject) => {
            api.post('/api/services/app/classesExpend/getCateGoriesList',null, Response => {
              resolve(Response.result)
            },error=>{
              reject(error)
            })
         })  
    } ,
    getChildCateGoriesList(){
        return new Promise((resolve, reject) => {
            api.post('/api/services/app/classesExpend/getChildCateGoriesList?CategoryId='+ 0,null, Response => {
              resolve(Response.result)
            },error=>{
              reject(error)
            })
         })  
    } ,
    getclassList(postdata){
        return new Promise((resolve, reject) => {
            api.post('/api/services/app/classesExpend/getTrainClass',postdata, Response => {
              resolve(Response.result)
            },error=>{
              reject(error)
            })
         })  
    } ,
    /* 课程详情 */
    getCourseInfo(id){
        return new Promise((resolve, reject) => {
            api.post('/api/services/app/trainCourseExpend/GetCourseDetail?_courseId='+id,null, Response => {
              resolve(Response.result)
            },error=>{
              reject(error)
            })
         })  
    } ,
    getDeadLine(classId,courseId){
        return new Promise((resolve, reject) => {
            api.post('/api/services/app/trainCourseExpend/GetDeadLine?_classId='+classId+'&_courseId='+courseId,null, Response => {
              resolve(Response.result)
            },error=>{
              reject(error)
            })
         })  
    } ,
    getEvaluationPageListByCourseId(postdata){
        return new Promise((resolve, reject) => {
            api.post('/api/services/app/evaluations/GetEvaluationPageListByCourseId',postdata, Response => {
              resolve(Response.result)
            },error=>{
              reject(error)
            })
         })  
    } ,
    getQuestions(postdata){ // 获取问答
        return new Promise((resolve, reject) => {
            api.post('/api/services/app/trainCourses/GetQuestionsByCourse',postdata, Response => {
              resolve(Response.result)
            },error=>{
              reject(error)
            })
         })  
    },
    getChildQuestions(id){ // 获取问答回复
        return new Promise((resolve, reject) => {
            api.post('/api/services/app/trainCourses/GetChildQuestionsByCourse?TrainCourseQuestionsId=' + id,null, Response => {
              resolve(Response.result)
            },error=>{
              reject(error)
            })
         })  
    },
    CreateTrainCollect(postdata){ //收藏课程
        return new Promise((resolve, reject) => {
            api.post('/api/services/app/collects/CreateTrainCollect',postdata, Response => {
              resolve(Response)
            },error=>{
              reject(error)
            })
         })  
    } ,
    IsJoinCourse(cid){  //是否属于某个课程
        return new Promise((resolve, reject) => {
            api.get('/api/TrainCourse/IsJoinCourse?isBase64=false&CourseId=' + cid ,null, Response => {
                resolve(Response.result)
              
            },error=>{
              reject(error)
            })
         })  
    },
    submitQuestion(postdata){  // 提交问答
      return new Promise((resolve, reject) => {
          api.post('/api/services/app/trainCourses/CreateCourseQuestion' ,postdata, Response => {
              if (Response.result == 0) {
                  resolve(false)
              } else {
                  resolve(true)
              }
            
          },error=>{
            reject(error)
          })
       })  
  },
  submitPinglun(postdata){  // 提交评论
    return new Promise((resolve, reject) => {
        api.post('/api/services/app/evaluations/CreateTrainEvaluation'  ,postdata, Response => {
            if (Response.result == 0) {
                resolve(false)
            } else {
                resolve(true)
            }
          
        },error=>{
          reject(error)
        })
     })  
  },
  UpdateQuestionViewCount(id){  // 浏览数
    return new Promise((resolve, reject) => {
        api.post('/api/services/app/trainCourses/UpdateQuestionViewCount?QuestionId=' + id ,null, Response => {
          resolve(Response.result)
        },error=>{
          reject(error)
        })
     })  
  },
  AdoptionCourseQuestion( cid,qid){  // 浏览数
    return new Promise((resolve, reject) => {
        api.post('/api/services/app/trainCourses/AdoptionCourseQuestion?TrainCourseId='+ cid +'&TrainCourseQuestionsId=' + qid ,null, Response => {
          resolve(Response.result)
        },error=>{
          reject(error)
        })
     })  
  },

    getclassDetail(id){
        return new Promise((resolve, reject) => {
            api.post('/api/services/app/classesExpend/GetClassDetail?id='+id,null, Response => {
              resolve(Response.result)
            },error=>{
              reject(error)
            })
         })  
    } ,
    getclassTeachers(classId,type){
        return new Promise((resolve, reject) => {
            api.post('/api/services/app/classesExpend/GetClassTeacherList?classId='+ classId+'&type='+type,null, Response => {
              resolve(Response.result)
            },error=>{
              reject(error)
            })
         })  
    } ,
    getclassStudents(id){
        return new Promise((resolve, reject) => {
            api.post('/api/services/app/classesExpend/GetClassStudents?classId='+id,null, Response => {
              resolve(Response.result)
            },error=>{
              reject(error)
            })
         })  
    } ,
    getclassFiles(req){
      return new Promise((resolve, reject) => {
          api.post('/api/services/app/classFile/GetClassFilesPage',{
            maxResultCount:req.pageSize,
            pageIndex:req.page,
            classId:req.classId,
          }, Response => {
            resolve(Response.result)
          },error=>{
            reject(error)
          })
       })  
    } ,
    //阶段测试
    getclassExam(classId){
      return new Promise((resolve, reject) => {
          api.post('/api/services/app/classExam/GetClassExams?classId='+classId,null, Response => {
            resolve(Response.result)
          },error=>{
            reject(error)
          })
       })  
    } ,
    
    getclassResult(req){
      return new Promise((resolve, reject) => {
          api.post('/api/services/app/classes/ConsequentList',{
            maxResultCount:req.pageSize,
            pageIndex:req.page,
            sorting:"CreationTime desc",
            classId:req.classId,
            resType: req.resType!=undefined? req.resType:0
          }, Response => {
            resolve(Response.result)
          },error=>{
            reject(error)
          })
       })  
    } ,
    getclassLives(req){
      return new Promise((resolve, reject) => {
          api.post('/api/services/app/classesExpend/LiveListByClass',{
            pageSize:req.pageSize,
            maxResultCount:req.pageSize,
            pageIndex:req.page,
            classId:req.classId
          }, Response => {
            resolve(Response.result)
          },error=>{
            reject(error)
          })
       })  
    } ,
    getclassCourses(req){
      return new Promise((resolve, reject) => {
          api.post('/api/services/app/classesExpend/GetTrainCourse',{
            maxResultCount:req.pageSize,
            pageIndex:req.page,
            classId:req.classId,
            categoryId:0
          }, Response => {
            resolve(Response.result)
          },error=>{
            reject(error)
          })
       })  
    } ,
    collectClass(id){
      return new Promise((resolve, reject) => {
          api.post('/api/services/app/classes/CollectClass?classId='+id,null, Response => {
            resolve(Response.result)
          },error=>{
            reject(error)
          })
       })  
    } ,
    delcollectClass(id){
      return new Promise((resolve, reject) => {
          api.post('/api/services/app/classes/DeleteClassCollect?classId='+id,null, Response => {
            resolve(Response.result)
          },error=>{
            reject(error)
          })
       })  
    } ,
    getClassNotice(id){
      return new Promise((resolve, reject) => {
          api.post('/api/services/app/notices/GetAllNotice',{
            type:1,
            relationId:id
          }, Response => {
            resolve(Response.result)
          },error=>{
            reject(error)
          })
       })  
    } ,
    IsJoinClass(cid){  //是否属于某个班级
      return new Promise((resolve, reject) => {
          api.post('/api/services/app/classes/IsThisClass?classId=' + cid ,null, Response => {
              resolve(Response.result)
            
          },error=>{
            reject(error)
          })
       })  
  },
  // /api/services / app / trainCourses / GetUserCourses
  getMyCourseList(courseData){
    if (!courseData.stopajax) {
      return new Promise((resolve, reject) => {
        api.post('/api/services/app/trainCourses/GetUserCourses', {
          maxResultCount: courseData.MaxResultCount,
          pageIndex: courseData.PageIndex,
          skipCount: courseData.PageIndex*courseData.MaxResultCount,
          sorting: "Id desc"
        }, Response => {
          resolve(Response.result)
        }, error => {
          reject(error)
        })
      })
    }
  },
  getMyCollectionClassList(postData) {
     if (!postData.stopajax) {
         return new Promise((resolve, reject) => {
           api.post('/api/services/app/collects/GetCollectClass', {
             maxResultCount: postData.MaxResultCount,
             skipCount: postData.SkipCount,
             sorting: "Id desc"
           }, Response => {
             resolve(Response.result)
           }, error => {
             reject(error)
           })
         })
       }
     },
  getMyCollectionCourseList(postData) {
    if (!postData.stopajax) {
      return new Promise((resolve, reject) => {
        api.post('/api/services/app/collects/GetCollectCourse', {
          courseType: postData.CourseType,
          maxResultCount: postData.MaxResultCount,
          skipCount: postData.SkipCount,
          sorting: "Id desc"
        }, Response => {
          resolve(Response.result)
        }, error => {
          reject(error)
        })
      })
    }
  },
  getMyQuesitionsList(postData) {
      if (!postData.stopajax) {
        return new Promise((resolve, reject) => {
          api.post('/api/services/app/trainCourses/GetMyCourseQuestions', {
            maxResultCount: postData.MaxResultCount,
            skipCount: postData.SkipCount,
            pageIndex: postData.PageIndex,
            sorting: "Id desc"
          }, Response => {
            resolve(Response.result)
          }, error => {
            reject(error)
          })
        })
      }
  },
  getMyAnswersList(postData) {
    if (!postData.stopajax) {
      return new Promise((resolve, reject) => {
        api.post('/api/services/app/evaluations/GetEvaluationPageListByUser', {
            maxResultCount: postData.MaxResultCount,
            pageIndex: postData.PageIndex,
            sorting: "Id desc"
        }, Response => {
            resolve(Response.result)
        }, error => {
            reject(error)
        })
      })
    }
  },
  getUserAllInfo(userid) {
    return new Promise((resolve, reject) => {
      api.post('/api/services/app/user/GetUser', {
        userId: userid,
      }, Response => {
        resolve(Response.result)
      }, error => {
        reject(error)
      })
    })
  },
  getLiveListByMyInitiate(postData){
   return new Promise((resolve, reject) => {
     api.post('/api/services/app/LiveBroadcast/GetLiveListByMyInitiate', {
       MaxResultCount: postData.MaxResultCount,
       pageIndex: postData.PageIndex,
       skipCount: postData.SkipCount, 
     }, Response => {
       resolve(Response.result)
     }, error => {
       reject(error)
     })
   })
  },
  getLiveListByMyJoin(postData) {
    return new Promise((resolve, reject) => {
      api.post('/api/services/app/LiveBroadcast/GetLiveListByMyJoin', {
        MaxResultCount: postData.MaxResultCount,
        pageIndex: postData.PageIndex,
        skipCount: postData.SkipCount, 
      }, Response => {
        resolve(Response.result)
      }, error => {
        reject(error)
      })
    })
  },
  getMyTrainingLists(postData) {
    return new Promise((resolve, reject) => {
      api.post('/api/services/app/classes/GetUserClasses', {
            Sorting: postData.Sorting,
            PageIndex: postData.PageIndex,
            MaxResultCount: postData.MaxResultCount,
            status: postData.status,
            stopajax: postData.stopajax
          }, Response => {
        resolve(Response.result)
      }, error => {
        reject(error)
      })
    })
  },
  
  getTotal(classId,flg) {
    return new Promise((resolve, reject) => {
      api.post('/api/services/app/classes/GetTotal?classId=' + classId + '&flg=' + flg, null, Response => {
        resolve(Response)
      }, error => {
        reject(error)
      })
    })
  },
  getMyCourseTime(classId,userId) {
    return new Promise((resolve, reject) => {
      api.post('/api/services/app/classes/GetUserClasses1?classId=' + classId + '&userid=' + userId, null, Response => {
        resolve(Response)
      }, error => {
        reject(error)
      })
    })
  },
  getMyClassNumber(classId) {
    return new Promise((resolve, reject) => {
      //api.post('/api/services/app/classes/GetMyClassNumber?classId=' + classId, null, Response => {
      api.post('/api/services/app/classes/GetClassCodeAndStudentCode?classId=' + classId, null, Response => {  
        resolve(Response)
      }, error => {
        reject(error)
      })
    })
  },
  //国际“双元制”职业教育专题培训 判断是否合格 这个班级需要走原来老的逻辑 其他班级不应调用此方法
  getMySpecialClassNumber(classId) {
    if(classId==3087){
      return new Promise((resolve, reject) => {
        api.post('/api/services/app/classes/GetMyClassNumber?classId=' + classId, null, Response => {
          resolve(Response)
        }, error => {
          reject(error)
        })
      })
    }
  },

  getMyClassConsequentCount(classId) {
    return new Promise((resolve, reject) => {
      api.post('/api/services/app/classes/GetMyClassConsequentCount?classId=' + classId, null, Response => {
        resolve(Response)
      }, error => {
        reject(error)
      })
    })
  },
  getMoveLive(liveId){
    return new Promise((resolve, reject) => {
      api.post('/api/services/app/liveBroadcast/Delete?id='+ liveId, null, Response => {
        resolve(Response)
      }, error => {
        reject(error)
      })
    })
  },
  getMyAllClass() {
    return new Promise((resolve, reject) => {
      api.post('/api/services/app/classes/GetMyAllClass', null, Response => {
        resolve(Response)
      }, error => {
        reject(error)
      })
    })
  },
  //http://www.spzxedu.com/zbtest/createLiveBroad
  createMyZb(roomData){
    return new Promise((resolve, reject) => {
      api.post('/zbtest/createLiveBroad', {
        Title: roomData.zbTitle,
        StartDate: roomData.zbStartTime,
        TimeLong: roomData.zbTotalTime,
        Content: roomData.zbIntroduction,
        Scale: roomData.zbTotalPeople,
        AuditStatus: roomData.AuditStatus,
        AuditMind: roomData.AuditMind,
        ClassId: roomData.ClassId,
        TeacherId: roomData.TeacherId,
        CreatorUserId: roomData.CreatorUserId,
        CreationTimeL: roomData.zbCreateTime,
        EndDate: roomData.zbEndTime,
        Logo: roomData.zbimg
      }, Response => {
        resolve(Response)
      }, error => {
        reject(error)
      })
    })
  },
  uploadImageFile(fd){
   
    return new Promise((resolve, reject) => {
      api.post('/resource/UploadFile', fd, Response => {
        resolve(Response)
      }, error => {
        reject(error)
      })
    })
  },
  uploadHeadImage(fd) {

    return new Promise((resolve, reject) => {
      api.post('/Account/UpdateUserHeadImg', {
        image: fd
      }, Response => {
        resolve(Response)
      }, error => {
        reject(error)
      })
    })
  },
  //http: //www.spzxedu.com/admin/resources/UploadFile
  uploaderMyAchievement(formData) {  
    
    return new Promise((resolve, reject) => {
      api.post(
        "/admin/resources/UploadFile",
        formData,
        Response => {
          resolve(Response);
        },
        (error) => {
          reject(error);
        }
      );
    })
  },
  relationFileWithClaass(formData) {
    return new Promise((resolve, reject) => {
      api.post('/class/ConsequentSubmit', 
      formData,
      Response => {
        resolve(Response)
      }, error => {
        reject(error)
      })
    })
  },

  getMyUploadFileLists(data) {
    
    return new Promise((resolve, reject) => {
      api.post('/api/services/app/classes/MyConsequent', {
        sorting: "CreationTime desc",
        PageIndex: data.PageIndex,
        maxResultCount: data.MaxResultCount,
        status: 0
      }, Response => {
        resolve(Response)
      }, error => {
        reject(error)
      })
    })
  },
  deleteMyUploadFile(resourceId) {
    return new Promise((resolve, reject) => {
      api.post('/api/services/app/classes/DeleteConsequent?resourceIds=' + resourceId, null, Response => {
        resolve(Response)
      }, error => {
        reject(error)
      })
    })
  },
 
  updateUserPassword(Data){
    return new Promise((resolve, reject) => {
      api.post('/api/services/app/user/UpdateUserPassword', {
        "oldPassword": Data.OldPassword,
        "newPassword": Data.NewPassword
      }, 
      Response => {
        resolve(Response)
      }, error => {
        reject(error)
      })
    })
  },
  upadteUserNickName(nickName){
    return new Promise((resolve, reject) => {
      api.post('/account/UpdateUserNickname', {
        "nickname": nickName,
      },
        Response => {
          resolve(Response)
        }, error => {
          reject(error)
        })
    })
  },
  updateUserEmailAddress(emailAddress) {
    return new Promise((resolve, reject) => {
      api.post('/account/UpdateUserEmailAddress', {
        "emailAddress": emailAddress,
      },
        Response => {
          resolve(Response)
        }, error => {
          reject(error)
        })
    })
  },
  //https://www.spzxedu.com/api/Account/UpdateUserInfo
          
          //  Account / UpdateUserInfo
  updateUserInfo(data){
    return new Promise((resolve,reject) =>{
      api.post("/api/Account/UpdateUserInfo", {
        "emailAddress": data.emailAddress,
        "name": data.name,
        "schoolName": data.schoolName,
        "specialty": data.specialty,
        "positional": data.positional,
        "province": data.province,
        "city": data.city,
        "introduction": data.introduction,
        "team": data.team,
        "duty": data.duty,
        "nickName": data.nickname,
        "phoneNumber": data.phoneNumber,
        "userName": data.userName,
        "training": data.training,
        "Sex": data.sex,
        "HeadImage": data.headImage
      },Response =>{
          resolve(Response)
      },error =>{
          reject(error)
      })
    })
  },
  getMyTrainingTime(classId,userId) {
    return new Promise((resolve, reject) => {
      api.post('/api/services/app/liveBroadcast/GetUserClassLiveSumRecord?classId=' + classId + '&userid=' + userId, null, Response => {
        resolve(Response)
      }, error => {
        reject(error)
      })
    })
  },
  getUserLiveSumRecord(liveId, userId) {
    return new Promise((resolve, reject) => {
      api.post('/api/services/app/liveBroadcast/GetUserLiveSumRecord?id=' + liveId + '&userid=' + userId, null, Response => {
        resolve(Response)
      }, error => {
        reject(error)
      })
    })
  },
  
  getUserInfo() {
    return new Promise((resolve, reject) => {
      api.get('/api/Account/GetUserInfo', null, Response => {
        resolve(Response.result)
      }, error => {
        reject(error)
      })
    })
  },
}

export default comFun